module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ReissueClockView.js"));
	}, "ReissueClockView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ReissueClockView!./src/pages/PunchClock/ReissueClock/ReissueClockView.js
// module id = 1253
// module chunks = 438